/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PulseMonitorIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M22.5416667,20.7083333 C22.5416667,21.7166667 21.7166667,22.5416667 20.7083333,22.5416667 L3.29166667,22.5416667 C2.28241667,22.5416667 1.45833333,21.7166667 1.45833333,20.7083333 L1.45833333,3.29166667 C1.45833333,2.28241667 2.28241667,1.45833333 3.29166667,1.45833333 L20.7083333,1.45833333 C21.7166667,1.45833333 22.5416667,2.28241667 22.5416667,3.29166667 L22.5416667,20.7083333 Z" />
      <polyline points="1.45833333 9.70833333 5.125 9.70833333 6.95833333 6.95741667 8.79166667 9.70741667 10.625 5.58241667 13.375 14.29075 15.6666667 3.29075 17.5 9.70833333 22.5416667 9.70833333" />
      <path d="M5.125,19.7916667 L5.125,20.7083333" />
      <path d="M10.625,19.7916667 L10.625,20.7083333" />
      <path d="M16.125,19.7916667 L16.125,20.7083333" />
      <path d="M7.875,17.9583333 L7.875,20.7083333" />
      <path d="M13.375,17.9583333 L13.375,20.7083333" />
      <path d="M18.875,17.9583333 L18.875,20.7083333" />
    </g>
  </svg>
);

export default PulseMonitorIcon;
